// Define an array of 8 Bootstrap theme colors
const bootstrapColors = [
  '#007bff', // Primary
  '#28a745', // Success
  '#17a2b8', // Info
  '#dc3545', // Danger
  '#6c757d', // Secondary
  '#ffc107', // Warning
  '#f8f9fa', // Light
  '#343a40', // Dark
];


const bootstrapColors2 = [
  "#007bff", // Primary
  "#00cbff", // Primary
  "#a000a0", // Secondary
  "#28a745", // Success
  "#dc3545", // Danger
  "#ffc107", // Warning
  "#0fff4f", // Info
  "#e942f5", // Darkened Primary
  "#1e7e34", // Darkened Success
  "#754c4c", // Darkened Danger
  "#e0a800", // Darkened Warning
  "#138496", // Darkened Info
  "#e9ecef", // Lightened Light
  "#80bdff", // Light Primary
  "#6a02e0", // Light Secondary
  "#34ce57", // Light Success
  "#e27c79", // Light Danger
  "#ffe484", // Light Warning
  "#4dbdde", // Light Info
  "#d6d8d9", // Very Light
  "#343a40", // Dark
  "#5a6268", // Darkened Secondary
  "#f8f9fa", // Light
];

const colorMap = new Map(); // Use a Map instead of an array for better key-value mapping

// Helper function to get a consistent color for markers and tracks based on the key (mac_custom)
// Helper function to convert hex color to RGBA
const hexToRGBA = (hex, alpha = 1) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

  let r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } else {
      return `rgb(${r}, ${g}, ${b})`;
  }
};

// Modified getColorByDeviceKey to include an optional alpha parameter
export const getColorByDeviceKey = (key, alpha) => {
let color;

const key2 = key.toLowerCase();

if (colorMap.has(key2)) {
  color = colorMap.get(key2);
} else {
  color = bootstrapColors[colorMap.size % bootstrapColors.length];
  colorMap.set(key2, color);
}

// If alpha is provided, convert the color to RGBA format
if (alpha !== undefined) {
  color = hexToRGBA(color, alpha);
}

return color;
};

// getBootstrapColors remains unchanged
export const getBootstrapColors = () => {
return bootstrapColors2;
};
